"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.config = void 0;
const translation_json_1 = __importDefault(require("./lang/en/translation.json"));
const translation_json_2 = __importDefault(require("./lang/sl/translation.json"));
exports.config = {
    language: {
        // default language
        default: 'en',
        // supported language ('0' => ISO 639-1, '1' => translation key)
        supported: [
            ['en', 'ENGLISH'],
            ['sl', 'SLOVENIAN']
        ],
        // language resources (should be imported)
        resources: {
            en: { translation: translation_json_1.default },
            sl: { translation: translation_json_2.default }
        }
    },
    backend: {
        // backend core relative path
        corePath: '/api/core/v1',
        // backend storage relative path
        storagePath: '/api/storage/'
    },
    resources: {
        // resources location path
        path: 'assets/',
        images: {
            background: [
                { name: 'assets/images/image_1.png' },
                { name: 'assets/images/image_2.png' }
            ]
        }
    },
    webgl: {
        backgroundColor: '#b3b3b3',
        lights: {
            ambient: {
                // main light color
                color: 0xEFEFEF,
                // main light color intensity
                intensity: 4.5
            }
        },
        helpers: {
            grid: {
                // grid size
                size: 200,
                // grid size division
                division: 200,
                // grid color
                gridColor: 0x654321,
                centerColor: 0xac772e,
            },
            axes: {
                // axes size
                size: 100
            }
        }
    },
    measurement: {
        // max measurement lines allowed
        maxLinesAllowed: 10,
        // default scale, if not provided
        defaultScale: 1,
        colors: {
            // default line color if no other provided
            default: 0xffc107,
            // line colors
            options: [0xe91e63, 0x3f51b5, 0x2196f3, 0x4caf50]
        }
    }
};
